import { getBaseUrl } from '../../constant';
import { ACCESS_TOKEN_ENDPOINT } from '../constants';

let isRefreshing = false;
let pendingRequests = [];

function onRefreshComplete(newToken, error) {
  pendingRequests.forEach((cb) => cb(newToken, error));
  pendingRequests = [];
}

async function doRefresh() {
  const refreshToken = localStorage.getItem('refreshToken');
  const tenantID = localStorage.getItem('tenantID');

  if (!refreshToken) throw new Error('No refresh token');

  const response = await fetch(`${getBaseUrl()}${ACCESS_TOKEN_ENDPOINT}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refreshToken, tenantID }),
  });

  const data = await response.json();
  if (!response.ok || !data?.data?.accessToken) {
    throw new Error(data?.errors?.[0]?.reason || 'Token refresh failed');
  }

  const newAccessToken = data.data.accessToken;
  localStorage.setItem('googleToken', newAccessToken);
  return newAccessToken;
}

function forceLogout() {
  localStorage.removeItem('googleToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('tenantID');
  window.location.reload();
}

export async function fetchWithAuth(url, options = {}) {
  const token = localStorage.getItem('googleToken');
  const authOptions = {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await fetch(url, authOptions);

  if (response.status !== 401) return response;

  // Token expired — refresh once, then retry
  if (!isRefreshing) {
    isRefreshing = true;
    doRefresh()
      .then((newToken) => {
        isRefreshing = false;
        onRefreshComplete(newToken, null);
      })
      .catch((err) => {
        isRefreshing = false;
        onRefreshComplete(null, err);
      });
  }

  return new Promise((resolve, reject) => {
    pendingRequests.push((newToken, error) => {
      if (error) {
        forceLogout();
        reject(error);
        return;
      }
      const retryOptions = {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${newToken}`,
        },
      };
      fetch(url, retryOptions).then(resolve).catch(reject);
    });
  });
}
